import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CruiseLanguageService from "../../../../services/reservations/CruiseLanguageService";

export const REQUEST_UPDATE_CRUISE_LANGUAGE = "REQUEST_UPDATE_CRUISE_LANGUAGE";
export const UPDATE_CRUISE_LANGUAGE_SUCCESS = "UPDATE_CRUISE_LANGUAGE_SUCCESS";
export const UPDATE_CRUISE_LANGUAGE_ERROR = "UPDATE_CRUISE_LANGUAGE_ERROR";

function requestUpdateCruiseLanguage() {
  return {
    type: REQUEST_UPDATE_CRUISE_LANGUAGE,
  };
}

function updateCruiseLanguageSuccess(json) {
  return {
    type: UPDATE_CRUISE_LANGUAGE_SUCCESS,
    message: json.data,
  };
}

function updateCruiseLanguageError(json) {
  return {
    type: UPDATE_CRUISE_LANGUAGE_ERROR,
    error: json.data,
  };
}

export function updateCruiseLanguage(cruise_id, id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateCruiseLanguage());
    return CruiseLanguageService.putCruiseLanguage(cruise_id, id, payload).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(updateCruiseLanguageSuccess(json.data));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(updateCruiseLanguage(cruise_id, id, payload));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(updateCruiseLanguageError(json.data));
        }
      }
    );
  };
}
